import React from 'react';

const ProjectDetails = React.lazy(()=>import('./ProjectDetails'));
const ProjectInfo = React.lazy(()=>import('./ProjectInfo'));
const UploadUserDocument = React.lazy(()=>import('./UploadUserDocument'));
const ClientDocument = React.lazy(()=>import('./ClientDocument'));
const ProjectChat = React.lazy(()=>import('./ProjectChat'));
export {
    ProjectDetails,
    ProjectInfo,
    UploadUserDocument,
    ClientDocument,
    ProjectChat
}